export const toAbsoluteUrl = (pathname: string) =>
  process.env.REACT_APP_IP + pathname;


